export const DEFAULT_TIMEOUT = 20000;

export const TIMEOUT_10_SEC = 10000;
export const TIMEOUT_59_SEC = 59000;
export const TIMEOUT_60_SEC = 60000;
export const TIMEOUT_65_SEC = 65000;
export const TIMEOUT_90_SEC = 90000;
export const TIMEOUT_95_SEC = 95000;
export const TIMEOUT_100_SEC = 100000;
export const TIMEOUT_120_SEC = 120000;
